import type { SVGProps } from 'react';
import * as React from 'react';

const CnvIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/cnv">
      <g id="Vector" filter="url(#filter0_dd_3816_38056)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="#B91C1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_38056)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2223 7.44444C26.2223 8.9172 27.4162 10.1111 28.889 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="white"
          fillOpacity={0.3}
        />
      </g>
      <path
        id="Vector_2"
        d="M28.9508 20.796C28.7313 21.4052 28.173 21.6878 27.7016 22.0302C27.2583 22.3524 27.0415 22.6824 27.1372 23.253C27.2004 23.6305 27.1416 24.0431 27.0749 24.4232C27.0266 24.6962 27.1109 24.8182 27.3382 24.9323C27.6744 25.1079 28.001 25.2957 28.3205 25.4968C28.6918 25.7311 28.7735 26.005 28.5593 26.3878C28.0062 27.3774 27.4427 28.3608 26.8686 29.3382C26.6333 29.7376 26.3559 29.8043 25.9486 29.5883C25.615 29.4128 25.2841 29.2275 24.9646 29.0256C24.7644 28.8984 24.6134 28.8975 24.4256 29.0572C23.8979 29.4959 23.2979 29.8393 22.6523 30.072C22.4355 30.151 22.3749 30.2739 22.389 30.4925C22.4039 30.8436 22.3943 31.1948 22.389 31.5389C22.3741 32.1112 22.1529 32.3333 21.591 32.3333C20.4999 32.3333 19.4087 32.3289 18.3176 32.3245C17.9059 32.3245 17.6768 32.1226 17.6557 31.7022C17.6355 31.2957 17.6399 30.8875 17.6557 30.4811C17.6654 30.2564 17.5872 30.144 17.3757 30.065C16.7334 29.8283 16.135 29.4862 15.6051 29.0529C15.4348 28.9124 15.2978 28.8852 15.1047 29.0125C14.8142 29.2038 14.4955 29.3531 14.2032 29.5392C14.0905 29.6187 13.9616 29.6722 13.8256 29.6955C13.6897 29.7189 13.5503 29.7117 13.4175 29.6744C13.3 29.5465 13.1917 29.4104 13.0936 29.267C12.5529 28.3523 12.0191 27.4335 11.4924 26.5107C11.2229 26.0366 11.2897 25.7619 11.7382 25.4836C12.1324 25.2387 12.6898 25.0956 12.8891 24.7453C13.0761 24.417 12.8803 23.8754 12.868 23.4286C12.861 23.196 12.8426 22.9493 12.9093 22.7342C13.0611 22.2479 12.89 21.9766 12.4387 21.7976C12.1861 21.685 11.9443 21.5495 11.7163 21.3929C11.3555 21.1655 11.2589 20.8662 11.4617 20.501C12.0218 19.4985 12.595 18.5031 13.1709 17.5093C13.3728 17.1582 13.6844 17.0924 14.032 17.2697C14.3946 17.4549 14.7457 17.6621 15.0959 17.8701C15.2583 17.9667 15.3821 18.0027 15.5542 17.857C16.1032 17.399 16.7267 17.0385 17.3976 16.7913C17.5951 16.7167 17.661 16.6104 17.6548 16.405C17.6417 16.0126 17.6425 15.615 17.6592 15.2261C17.6777 14.7731 17.8901 14.559 18.3439 14.5572C19.45 14.5525 20.5564 14.5578 21.663 14.573C22.1669 14.58 22.4373 14.8126 22.382 15.2955C22.2731 16.2453 22.4083 17.0028 23.5126 17.2179C24.1517 17.9035 24.8188 17.7595 25.5009 17.2899C25.6002 17.2294 25.7041 17.1768 25.8117 17.1328C26.4683 16.8202 26.7834 16.9089 27.1547 17.526C27.6709 18.3854 28.1774 19.2518 28.6945 20.1112C28.8185 20.3231 28.9052 20.5547 28.9508 20.796ZM16.6919 25.5652C16.8446 25.2791 16.9763 25.0385 17.1027 24.7954C17.8049 23.4295 18.6775 22.1434 19.1735 20.6695C19.2131 20.5406 19.2809 20.4221 19.372 20.3227C19.4631 20.2232 19.5752 20.1453 19.7002 20.0946C20.8624 19.5415 22.0177 18.9727 23.1913 18.4012C21.1556 16.9747 18.0235 17.0845 15.8579 19.1035C13.9161 20.911 13.4325 24.0703 14.8177 26.4352C16.2661 28.9071 19.2463 30.0395 21.8983 29.1345C24.5502 28.2294 26.14 25.5433 25.9565 23.4479C25.8275 23.5357 25.7107 23.612 25.6054 23.6972C24.7275 24.3898 23.8436 25.0815 22.9719 25.7803C22.8174 25.9032 22.6725 25.9866 22.4619 25.9638C20.7176 25.7724 18.9725 25.9102 17.2273 25.9638C17.1167 25.9638 16.9824 26.0208 16.8648 25.9041C16.9341 25.8681 16.971 25.847 17.0096 25.8286C18.0727 25.3238 19.1366 24.8217 20.1979 24.3134C20.4367 24.1993 20.6518 24.1379 20.9362 24.2186C21.5445 24.3889 22.1651 23.9641 22.3153 23.3329C22.3944 23.0356 22.3524 22.7191 22.1986 22.4527C22.0447 22.1863 21.7915 21.9917 21.4945 21.9117C20.8695 21.7361 20.1531 22.0635 20.0583 22.6824C19.9758 23.2267 19.6642 23.5014 19.2683 23.7832C18.5476 24.3003 17.8436 24.8366 17.129 25.3633C17.0175 25.4476 16.935 25.5845 16.6919 25.5652Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38056"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38056" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38056" result="effect2_dropShadow_3816_38056" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38056" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38056"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.08} />
      </radialGradient>
    </defs>
  </svg>
);
export default CnvIcon;
